import { IXPagination } from "./pagination.interface";

export const mapToXPagination = (paginationHeader: string | null): IXPagination => {
  if (paginationHeader) {
    return JSON.parse(paginationHeader);
  }
  return {
    CurrentPage: 0,
    TotalPages: 0,
    PageSize: 0,
    TotalCount: 0,
    HasPrevious: false,
    HasNext: false
  };
};
